var map = {
	"./EN/aggregade.json": 37336,
	"./EN/agreementsSettings.json": 94151,
	"./EN/cockpit.json": 94841,
	"./EN/common.json": 74846,
	"./EN/dashboard.json": 97981,
	"./EN/helmet.json": 56541,
	"./EN/helmetPlant.json": 77226,
	"./EN/historical.json": 21351,
	"./EN/history.json": 11652,
	"./EN/login.json": 45069,
	"./EN/management.json": 78982,
	"./EN/map.json": 52855,
	"./EN/multy.json": 99650,
	"./EN/notifications.json": 67101,
	"./EN/oilAnalysis.json": 91454,
	"./EN/overview.json": 39729,
	"./EN/plant.json": 97678,
	"./EN/profile.json": 86713,
	"./EN/realtime.json": 92080,
	"./EN/tables.json": 91267,
	"./EN/users.json": 32662,
	"./EN/yachts.json": 11397,
	"./IT/aggregade.json": 92586,
	"./IT/agreementsSettings.json": 28783,
	"./IT/cockpit.json": 20723,
	"./IT/common.json": 48392,
	"./IT/dashboard.json": 10121,
	"./IT/helmet.json": 62224,
	"./IT/helmetPlant.json": 87391,
	"./IT/historical.json": 83282,
	"./IT/history.json": 33843,
	"./IT/login.json": 38171,
	"./IT/management.json": 50419,
	"./IT/map.json": 50809,
	"./IT/multy.json": 68133,
	"./IT/notifications.json": 99982,
	"./IT/oilAnalysis.json": 72879,
	"./IT/overview.json": 36613,
	"./IT/plant.json": 89047,
	"./IT/profile.json": 40226,
	"./IT/realtime.json": 99092,
	"./IT/tables.json": 96382,
	"./IT/users.json": 53814,
	"./IT/yachts.json": 90318
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88479;